import { useMutation } from '@apollo/client';
import { Button, FieldInput } from 'aimo-ui';
import { showToast } from 'components/common/CustomToast';
import { UPDATE_RFID_TAG_NAME } from 'graphql/mutations/updateRfidTagName';
import { GET_CUSTOMER_RFID_TOKENS } from 'graphql/queries/getCustomerRfidTokens';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRfidStore } from 'stores/rfidStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import {
  Mutation,
  MutationUpdateRfidTagNameArgs,
} from 'types/generatedSchemaTypes';
import { isIos } from 'utils/deviceUtils';
import { useUiStore } from 'stores/uiStore';

export const EditOrDeleteRfid: React.FC = () => {
  const { t } = useTranslation();
  const tagName = useRfidStore((state) => state.currentTagName);
  const setCurrentTagName = useRfidStore((state) => state.setCurrentTagName);
  const serialNumber = useRfidStore((state) => state.currentSerialNumber);

  const [initialTagName] = useState(tagName);

  const [updateRfidTagName, { loading }] = useMutation<
    Mutation,
    MutationUpdateRfidTagNameArgs
  >(UPDATE_RFID_TAG_NAME, {
    awaitRefetchQueries: true,
    refetchQueries: [{ query: GET_CUSTOMER_RFID_TOKENS }],
    onCompleted: () => {
      showToast(
        t('success.rfidTokenUpdateName', { tagName: tagName }),
        'success'
      );
      useUiStore.getState().setSheetModal('');
    },
    onError: () => showToast('error.rfidTokenUpdate', 'error'),
  });

  const handleUpdateTagName = () => {
    updateRfidTagName({
      variables: {
        input: {
          serialNumber: serialNumber,
          name: tagName.trim(),
        },
      },
    });
  };

  const handleDeleteTag = () => {
    if (!serialNumber) {
      return;
    }
    useUiStore.getState().setSheetModal('confirmRfidTagRemoval');
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper mb={25} mt={25}>
        <FieldInput
          testID="tag-name-input"
          title={t('account.tagsAndCards.registerRfid.tagSuccess.tagName')}
          value={tagName}
          onChangeText={setCurrentTagName}
          isSheet={isIos}
          placeholder={t(
            'account.tagsAndCards.registerRfid.tagSuccess.placeholder'
          )}
        />
      </StyledWrapper>

      <StyledWrapper mb={25}>
        <Button
          testID="update-button"
          size="l"
          text={t('button.save')}
          onPress={handleUpdateTagName}
          disabled={
            initialTagName.trim() === tagName.trim() || tagName.trim() === ''
          }
          loading={loading}
        />
      </StyledWrapper>

      <StyledWrapper mb={25}>
        <Button
          testID="delete-button"
          size="l"
          text={t('account.tagsAndCards.removeTag')}
          onPress={handleDeleteTag}
          disabled={loading}
          buttonType="tertiary"
        />
      </StyledWrapper>
    </StyledWrapper>
  );
};
export default EditOrDeleteRfid;
